import { render } from "./new-material.vue?vue&type=template&id=00df341f&ts=true"
import script from "./new-material.vue?vue&type=script&lang=ts"
export * from "./new-material.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__